import { useEffect } from 'react';
import { i18n } from "@euroland/libs";

const useInstructionHighChart = (chatContainerRef) => {

  useEffect(() => {
    const chatContainerElement = chatContainerRef?.current?.container?.current;

    if (!chatContainerElement) return;
      const currentAriaLabel = chatContainerElement.getAttribute('aria-label');
      const newArialLabel = `${currentAriaLabel || ''} ${i18n.translate('graphTooltipInstruction')}`
      chatContainerElement.setAttribute('aria-label', newArialLabel)
  }, [chatContainerRef])

};

export default useInstructionHighChart;
